import {Component, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {RightSearchByPersonalIdComponent} from "../personal-id/right-search-by-personal-id.component";
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NgIf} from "@angular/common";
import {NgbTimepicker} from "@ng-bootstrap/ng-bootstrap";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {NchTempSssDto, RightSearchResult, Source} from "../../../../../generated-model/model";
import {current_datetime, updateFormAndValidity} from "../../../../app.constants";
import {RightSearchResource} from "../../../../service/RightSearchResource";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {ThaiDateTimePipe} from "../../../../shared/commons/thai-datetime.pipe";
import {BirthdateWithoutDate} from "../../../../shared/birthdate-without-date";
import {TempSssResource} from "../../../../service/TempSssResource";

@Component({
  selector: 'app-right-search-sss',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CustomErrorComponent,
    GtNgDatepickerModule,
    NgIf,
    SharedCommonModule,
    ThaiDateTimePipe
  ],
  templateUrl: './right-search-sss.component.html',
  styleUrl: './right-search-sss.component.scss'
})
export class RightSearchSssComponent implements OnInit {

  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  personalId = model<string>(undefined);
  source = model<Source>('NHSO');
  data = signal(undefined as RightSearchResult);

  checkRightsResource = inject(RightSearchResource);
  tempSssResource = inject(TempSssResource);

  confirmDialogService = inject(ConfirmDialogService);
  tempSSS: NchTempSssDto;

  ngOnInit() {
  }

  search() {
    let formValid = updateFormAndValidity(this.form);
    if (formValid) {
      this.checkRightsResource.searchPersonalFundAndSpecificSss(this.personalId(), 'NHSO')
        .subscribe({
          next: value => {
            if (value.personalFundDetailList.length > 0) {
              this.tempSssResource.findLast(this.personalId()).subscribe(e=>{
                this.tempSSS = e;
              })
              console.log('value', value)
              this.data.set(value);
              console.log('data', this.data())
            } else {
              this.confirmDialogService.open({
                content: 'เลขประจำตัวประชาชนนี้มีสิทธิกองทุนอื่น',
                confirmButtonMsg: 'ปิด',
                closeButtonMsg: 'HIDE'
              })
            }
          }
        });
    }
  }

  resetSearchParams() {
    this.personalId.set(undefined);
    this.source.set('NHSO');
  }
}
